import { ProductPromptType } from './redux/types';

// eslint-disable-next-line import/prefer-default-export
export const toProductPromptType = (productType: string | undefined): ProductPromptType | undefined => {
  switch (productType) {
    case 'sponsor':
    case 'premium':
    case 'day-pass':
    case 'single-habitat-day-pass':
    case 'educator':
    case 'explorer':
    case 'all-access':
    case 'tzplus':
    case 'general':
      return productType;
    default:
      return undefined;
  }
};
